<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ userData.fullName }}
        </p>
        <span class="user-status">@{{ userData.userName }}</span>
      </div>
      <b-avatar
        size="40"
        :src="avatar"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon v-if="!userData.fullName" icon="UserIcon" size="22" />
      </b-avatar>
    </template>

    <b-dropdown-item
      :to="{ name: 'user-profile-tab', params: { tab: 'thongtintaikhoan' } }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="UserIcon" class="mr-50" />
      <span>Hồ sơ</span>
    </b-dropdown-item>

    <!--Hoai Eidt
        <b-dropdown-item
          :to="{ name: 'apps-email' }"
          link-class="d-flex align-items-center"
        >
          <feather-icon
            size="16"
            icon="MailIcon"
            class="mr-50"
          />
          <span>Inbox</span>
        </b-dropdown-item>
        <b-dropdown-item
          :to="{ name: 'apps-todo' }"
          link-class="d-flex align-items-center"
        >
          <feather-icon
            size="16"
            icon="CheckSquareIcon"
            class="mr-50"
          />
          <span>Task</span>
        </b-dropdown-item>
        <b-dropdown-item
          :to="{ name: 'apps-chat' }"
          link-class="d-flex align-items-center"
        >
          <feather-icon
            size="16"
            icon="MessageSquareIcon"
            class="mr-50"
          />
          <span>Chat</span>
        </b-dropdown-item>

        -->
    <b-dropdown-divider />

    <!-- <b-dropdown-item
      :to="{ name: 'user-settings' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="SettingsIcon" class="mr-50" />

      <span>Cài đặt</span>
    </b-dropdown-item> -->
    <!--
        <b-dropdown-item
          :to="{ name: 'pages-pricing' }"
          link-class="d-flex align-items-center"
        >
          <feather-icon
            size="16"
            icon="CreditCardIcon"
            class="mr-50"
          />
          <span>Pricing</span>
        </b-dropdown-item>
        <b-dropdown-item
          :to="{ name: 'pages-faq' }"
          link-class="d-flex align-items-center"
        >
          <feather-icon
            size="16"
            icon="HelpCircleIcon"
            class="mr-50"
          />
          <span>FAQ</span>
        </b-dropdown-item>
        -->
    <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
      <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
      <span>Đăng xuất</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
// TODO: T-DropdownUser
import {
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
} from "bootstrap-vue";
import { avatarText } from "@core/utils/filter";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ref, watch } from "@vue/composition-api";
import UseUserInfo from "@/services/api/DefaultTemplate/AuthService";

import {
  UserLogout,
  ClearUserData,
  GetUserInfo,
} from "@/services/api/DefaultTemplate/AuthService";

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  data() {
    return {
      isWait: false,
      avatarText,
    };
  },
  // watch: {
  //   GetUserInfo(newVal, oldVal) {
  //     console.log("object");
  //     this.userData.avatar = newVal.avatar
  //       ? process.env.VUE_APP_USER_FILE + "/" + newVal.avatar
  //       : newVal.avatar;
  //   },
  // },
  created() {
    console.log("userData", this.userData);
    this.avatar = this.userData.avatar
      ? process.env.VUE_APP_BASE_API + "/files/view/" + this.userData.avatar
      : this.userData.avatar;
  },
  methods: {
    // TODO User Logout
    logout() {
      if (this.isWait) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: `Notification`,
            icon: "CoffeeIcon",
            variant: "info",
            text: `Login in Progress`,
          },
        });
      } else {
        this.isWait = true;
        UserLogout();
        this.$router.replace("/login").then(() => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Success`,
              icon: "CheckIcon",
              variant: "success",
              text: "Đăng xuất thành công!",
            },
          });
        });
        // .then((res) => {
        //   if (res["isError"]) {
        //     this.isWait = false;
        //     this.$toast({
        //       component: ToastificationContent,
        //       position: "top-right",
        //       props: {
        //         title: `Error`,
        //         icon: "AlertTriangleIcon",
        //         variant: "error",
        //         text: res["message"],
        //       },
        //     });
        //   } else {
        //     ClearUserData(this.$ability);
        //     this.$router.replace("/login").then(() => {
        //       this.$toast({
        //         component: ToastificationContent,
        //         position: "top-right",
        //         props: {
        //           title: `Success`,
        //           icon: "CheckIcon",
        //           variant: "success",
        //           text: res["message"],
        //         },
        //       });
        //     });
        //   }
        // });
      }
    },
  },

  setup(props, { emit }) {
    // const { refUserInfo } = UseUserInfo();
    const data = GetUserInfo();
    const userData = data;

    const avatar = ref(null);

    // watch(userData.value, (val, oldVal) => {
    //avatar.value = userData.value.avatar;
    // console.log("UserDropdown2, ", val, oldVal);
    // });

    return {
      userData,
      avatar,
    };
  },
};
</script>
